import type { CategoryNode } from 'tradera/backend/data/category-data';
import type { SUPPORTED_LANGUAGES } from 'tradera/lang/constants.mjs';
import {
    useCurrentLanguage,
    useTranslator,
    useUrlLocalizer
} from 'tradera/lang/translate';
import { useGetCategoriesQuery } from 'tradera/state/services/categories-api';

type TopLevelCategoriesProps = {
    topLevelCategories: CategoryNode[];
};

const TopLevelCategories = ({
    topLevelCategories
}: TopLevelCategoriesProps) => {
    const { toLocalizedUrl } = useUrlLocalizer();

    return (
        <>
            {topLevelCategories?.map((category) => (
                <a key={category.id} href={toLocalizedUrl(category.href)}>
                    {category.name}
                </a>
            ))}
        </>
    );
};

export const inspirationLinks: Record<
    (typeof SUPPORTED_LANGUAGES)[number],
    string
> = {
    sv: '/inspiration',
    da: '/info/da/inspiration'
};

type SeoLinksProps = {
    isLoggedIn: boolean;
};

export const SeoLinks = ({ isLoggedIn }: SeoLinksProps) => {
    const { t } = useTranslator();
    const { language } = useCurrentLanguage();
    const { data: topLevelCategories } = useGetCategoriesQuery({
        level: 1
    });

    const inspirationLink = inspirationLinks[language];

    return (
        <div className="hidden">
            {(topLevelCategories || []).length >= 0 && (
                <TopLevelCategories
                    topLevelCategories={topLevelCategories || []}
                />
            )}
            {!isLoggedIn && inspirationLink && (
                <a href={inspirationLink}>{t('siteHeader_inspiration')}</a>
            )}
        </div>
    );
};
